import { render, staticRenderFns } from "./user-layout.vue?vue&type=template&id=0cfb1a0e&scoped=true&"
import script from "./user-layout.vue?vue&type=script&lang=js&"
export * from "./user-layout.vue?vue&type=script&lang=js&"
import style0 from "./user-layout.vue?vue&type=style&index=0&id=0cfb1a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb1a0e",
  null
  
)

export default component.exports